import React from 'react';

const InstallBanner = ({ isInstallable, onInstall }) => {
  if (!isInstallable) return null;
  
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gradient-to-r from-orange-600 via-pink-600 to-purple-600 text-white p-4 flex items-center justify-between shadow-2xl animate-fade-in">
      <span className="text-sm font-medium">Install CSB 2025 app for offline access 🏖️</span>
      <button
        onClick={onInstall}
        className="bg-white text-purple-600 px-4 py-2 rounded-full font-bold text-sm hover:bg-white/90 transition-all touch-scale shadow-lg"
        type="button"
      >
        Install
      </button>
    </div>
  );
};

export default InstallBanner;